import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Company } from '../../models/models';
import { FieldHasValuePipe } from './pipes/field-has-value.pipe';
import { MatTooltip } from '@angular/material/tooltip';
import { MatFormField } from '@angular/material/input';
import { MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  imports: [
    MatTooltip,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatButton,
    FieldHasValuePipe,
    ReactiveFormsModule,
    MatIcon,
    MatIconButton
  ],
  standalone: true
})
export class FiltersComponent implements OnChanges, OnDestroy {
  @Input() companies: Company[] = [];
  @Output() selectedCustomers = new EventEmitter<number[]>();
  companyControl: FormControl<null | number[]> = new FormControl(null);
  shouldDisableForm = false;
  companyId: string | string[] = [];

  private subscription = new Subscription();

  constructor(private route: ActivatedRoute) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['companies']) {
      this.subscription.add(
        this.route.queryParams
          .pipe(
            tap(params => {
              this.companyId = params['companyId'] ?? [];
              const companyIds = typeof this.companyId === 'string' ? [this.companyId] : this.companyId;
              this.shouldDisableForm = !!params['folder'];
              this.shouldDisableForm ? this.companyControl.disable() : this.companyControl.enable();
              this.companyControl.patchValue(companyIds.map(id => Number(id)) || null);
            })
          )
          .subscribe()
      );
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  filter() {
    this.selectedCustomers.emit(this.companyControl.value || []);
  }

  clear() {
    this.companyControl.reset();
    this.selectedCustomers.emit([]);
  }
}
